export default __webpack_public_path__ + "static/ipad-step1-f9357adfdaf8983a234fa14b98d5cc42.png";